import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
  AppCancelButton,
  AppSaveButton,
} from '../../buttons/app-button/AppButton';
import { useStyles } from './AppBarWithButtons.styles';

interface IAppBarWithButtonsProps {
  cancelLabel?: string;
  submitLabel?: string;
  loading?: boolean;
  disabled?: boolean;
  cancelDisabled?: boolean;
  onClick?: () => void;
  onCancelClick: () => void;
  submitButtonProps?: Record<string, unknown>;
}

export function AppBarWithButtons(props: IAppBarWithButtonsProps) {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    onCancelClick,
    cancelLabel = t('common.cancel'),
    submitLabel = t('common.save'),
    loading,
    disabled,
    onClick,
    cancelDisabled,
    submitButtonProps,
  } = props;

  return (
    <Box className={classes.buttonsWrapper}>
      <AppCancelButton disabled={cancelDisabled} onClick={onCancelClick}>
        {cancelLabel}
      </AppCancelButton>
      <AppSaveButton
        {...submitButtonProps}
        onClick={onClick}
        type={onClick ? 'button' : 'submit'}
        disabled={disabled}
        loading={loading}>
        {submitLabel}
      </AppSaveButton>
    </Box>
  );
}
